import React, { useState } from 'react';

import { ThemeContext, themes } from '../../../module/ThemeManager';
import { Box, Container } from '@mui/material';
import { EsSignupHeader } from '../../Header/EsSignupHeader';

import { EsSignupForm, SignUpdata } from '../../EsSignupForm/EsSignupForm';
import { TUserField } from '../../../redux/user/actions';
import { ROUTES } from '../../../types/global/routes.types';
import { Spotlight } from '../../Spotlight/Spotlight';
import { AnimationBackground } from '../../Spotlight/AnimationBackground';
import { TOnChangePayload } from '../../EsSignupForm/Interests';

export interface ISignUpProps {
    onSubmitSignUpOTP: (data: SignUpdata, code?: string[]) => void;
    checkUserDataAvailability: (data: SignUpdata, callBack: () => void, field: TUserField) => void;
    userNameAvailable: (userName: string) => void;
    getSignUpOTP: (data: SignUpdata, callBack: () => void, resend?: boolean) => void | Promise<unknown>;
    updateUserDetails: (details: TOnChangePayload, callBack?: () => void) => void;
    loading?: boolean;
    otpLoading?: boolean;
    resendInProgress?: boolean;
}

const EsSignupContainer: React.FC<ISignUpProps> = ({
    onSubmitSignUpOTP,
    checkUserDataAvailability,
    userNameAvailable,
    getSignUpOTP,
    loading,
    otpLoading,
    resendInProgress,
    updateUserDetails,
}) => {
    const [showBg, setShowBg] = useState(true);
    const handleBeyondFirstStep = (data: SignUpdata, callBack: () => void, field: TUserField, step: number) => {
        checkUserDataAvailability(data, callBack, field);
        setShowBg(false);
    };

    return (
        <ThemeContext.Consumer>
            {({ themeStyle, darkModeEnabled, device }) => {
                return (
                    <Box
                        sx={{
                            width: '100vw',
                            height: '100vh',
                            minHeight: '100vh',
                            justifyContent: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            ...(darkModeEnabled && {
                                backgroundImage: `linear-gradient(to bottom, ${themes[themeStyle].true_black} 0%, ${themes[themeStyle].true_white} 500%)`,
                            }),
                            ...(!darkModeEnabled && {
                                backgroundColor: themes[themeStyle].tag_white_light,
                            }),
                        }}>
                        {/* <EsBackground /> */}
                        <EsSignupHeader route={ROUTES.ESLOGIN} />
                        <Spotlight withoutBg={!showBg} />

                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%',
                                flexDirection: 'row',
                            }}>
                            <Container
                                sx={{
                                    zIndex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                <EsSignupForm
                                    getSignUpOTP={getSignUpOTP}
                                    userNameAvailable={userNameAvailable}
                                    onSubmitSignUpOTP={onSubmitSignUpOTP}
                                    checkUserDataAvailability={handleBeyondFirstStep}
                                    updateUserDetails={updateUserDetails}
                                    loading={loading}
                                    otpLoading={otpLoading}
                                    resendInProgress={resendInProgress}
                                    formStyle={{ maxHeight: '900px' }}
                                />
                            </Container>
                            {showBg && <AnimationBackground />}
                        </Box>
                    </Box>
                );
            }}
        </ThemeContext.Consumer>
    );
};

export { EsSignupContainer };
